import { TextField, TextFieldProps } from '@mui/material';
import clsx from 'clsx';
import React from 'react';
import { useInputGroupContext } from './InputGroup';
import styles from './InputGroupInput.module.scss';

export type InputGroupInputProps = Omit<TextFieldProps, 'variant'>;

export const InputGroupInput = React.forwardRef<HTMLInputElement, InputGroupInputProps>(
    (props, ref) => {
        const { setFocused } = useInputGroupContext();

        const handleFocus = (e: React.FocusEvent<HTMLInputElement>) => {
            setFocused(true);
            props.onFocus?.(e);
        };

        const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
            setFocused(false);
            props.onBlur?.(e);
        };

        return (
            <TextField
                variant="outlined"
                {...props}
                ref={ref}
                onFocus={handleFocus}
                onBlur={handleBlur}
                className={clsx(styles.root, props.className)}
            />
        );
    }
);

InputGroupInput.displayName = 'InputGroupInput';
